module.exports = __webpack_public_path__ + "img/pic-03.73becccd.png";